import { useEffect, useMemo, useState } from "react"

import { ContentTag, provideComponent } from "scrivito"
import { useScreenSize } from "shared/lib/useScreenSize"

import { StorylaneWidget } from "./StorylaneWidgetClass"
import "./styles/_storylane-widget.scss"

provideComponent(StorylaneWidget, ({ widget }) => {
  const { isTablet, isMobile, isDesktop } = useScreenSize()

  const [renderIframe, setRenderIframe] = useState(false)

  // Delay rendering to avoid hydration mismatch
  useEffect(() => {
    const timeout = setTimeout(() => setRenderIframe(true), 1000)
    return () => clearTimeout(timeout)
  }, [])

  const desktopDemoId = widget.get("storylaneDesktopDemoId")
  const tabletDemoId = widget.get("storylaneTabletDemoId")
  const mobileDemoId = widget.get("storylaneMobileDemoId")
  const scrollTargetId = widget.get("scrollTargetId")

  const resolvedDemoId = useMemo(() => {
    if (isMobile) return mobileDemoId
    if (isTablet) return tabletDemoId
    if (isDesktop) return desktopDemoId
    return null
  }, [isMobile, isTablet, isMobile, desktopDemoId, tabletDemoId, mobileDemoId])

  if (!resolvedDemoId) return null

  return (
    <section className="storylane-widget" id={scrollTargetId}>
      <div className="storylane-widget__header">
        <ContentTag
          className="storylane-widget__title"
          content={widget}
          attribute="headline"
        />
        <ContentTag
          className="storylane-widget__description"
          content={widget}
          attribute="text"
        />
      </div>

      <div className="storylane-widget__demo">
        {renderIframe ? (
          <iframe
            title="Storylane Widget"
            className="storylane-widget-iframe"
            loading="lazy"
            src={`https://schako.storylane.io/demo/${resolvedDemoId}?embed=inline`}
            name="sl-embed"
            allowFullScreen
          />
        ) : null}
      </div>
    </section>
  )
})
